module.exports = __webpack_public_path__ + "img/lets-talk_icon.8f80e9af.svg";